import React from 'react'
import { WidgetProps } from '@rjsf/utils'
import { CloudServiceSource } from '@feedyou/utils'

import { CloudServiceSelect } from '../../../../../selects'

export const BotCloudServiceSelectWidget: React.FC<WidgetProps> = props => (
  <CloudServiceSelectWidget {...props} source="bot" />
)

export const ServerCloudServiceSelectWidget: React.FC<WidgetProps> = props => (
  <CloudServiceSelectWidget {...props} source="server" />
)

const CloudServiceSelectWidget: React.FC<WidgetProps & { source: CloudServiceSource }> = ({
  value,
  source,
  uiSchema,
  onChange
}) => {
  const kind = uiSchema?.kind
  const action = uiSchema?.action

  return (
    <span style={{ width: 'calc(80% - 26px)' }}>
      <CloudServiceSelect
        kind={kind}
        action={action}
        source={source}
        value={value}
        onChange={onChange}
      />
    </span>
  )
}
